// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"350":"fd2cd41f","925":"aa2480ce"}[chunkId] + ".css";
};